module.exports = __webpack_public_path__ + "static/media/03-1-galeria-05-valentino@2x.695eec72.jpg";